<db-dialog-wrapper [dialog]="this">
  <div class="db-grant-access-copy-website-dialog" *ngIf="!accessGranted">
    <div class="db-grant-access-copy-website-dialog-image">
      <img src="assets/images/icons/click.svg" alt=""/>
    </div>
    <div class="db-grant-access-copy-website-dialog-title">Just click the button below to<br/>grant access to 10Web</div>
    <div class="db-grant-access-copy-website-dialog-desc">We will create a super optimized copy of your website with Google<br/>PageSpeed Score of 95+ in just 24 hours.</div>
    <div class="db-grant-access-copy-website-dialog-button">
      <a class="db-button db-button_yellow" (click)="sendRequest()"><span>optimize my website</span></a>
    </div>
  </div>
  <div class="db-grant-access-copy-website-sent-dialog" *ngIf="accessGranted">
    <div class="db-grant-access-copy-website-sent-dialog-image">
      <img src="assets/images/icons/letter_white_bg.svg" alt=""/>
    </div>
    <div class="db-grant-access-copy-website-sent-dialog-title">Congrats!</div>
    <div class="db-grant-access-copy-website-sent-dialog-desc">Your Website with 95+ Google PageSpeed Score<br/>will be ready in 24 hours.</div>
  </div>
</db-dialog-wrapper>
